import { BehaviorSubject, Observable } from 'rxjs';
import { DataService } from '../services/data/data.service';
import { DataSource } from '@angular/cdk/table';
import { HttpClient } from '@angular/common/http';
import { TableColumn } from '../components/table/table-column.model';
import { CollectionViewer } from '@angular/cdk/collections';
import { DataSourceParams } from '../components/table/interfaces/data-source-params.interface';

export abstract class CustomDataSource implements DataSource<any> {
  protected dataSubject = new BehaviorSubject<any[]>([]);
  protected loadingSubject = new BehaviorSubject<boolean>(false);
  protected totalNumberOfElementsSubject = new BehaviorSubject<number>(0);
  protected dataInitializedSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();
  public totalNumberOfElements$ = this.totalNumberOfElementsSubject.asObservable();
  public dataInitialized$ = this.dataInitializedSubject.asObservable();

  constructor(protected http: HttpClient, protected dataService: DataService) {}

  public connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.dataSubject.asObservable();
  }

  public disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
    this.totalNumberOfElementsSubject.complete();
  }

  public abstract loadData(params: DataSourceParams): void

  public getData(): any[] {
    return this.dataSubject.value;
  }

  public getDataElement(index: number): any {
    return this.dataSubject.value[index];
  }

  public addEmptyRow(additionalProperties?: {}) {
    const newRow = { ...additionalProperties };
    this.dataSubject.next([...this.dataSubject.value, newRow]);
  }

  public remove(index: number) {
    const data = this.dataSubject.value;
    data.splice(index, 1);
    this.dataSubject.next(data);
  }

  public initializeUneditableFields(uneditableFieldNames: string[]) {
    const data = this.dataSubject.value;

    data.forEach((element) => {
      element.initialValues = [];
      uneditableFieldNames.forEach((field) => {
        if (element[field]) element.initialValues.push(field);
      });
    });

    this.dataSubject.next(data);
  }

  public getAllDropdownValues(column: TableColumn) {
    return column.cell as { value: any }[];
  }

  public getDropdownValues(column: TableColumn): { value: any }[] {
    const data = this.dataSubject.value;

    if (column.type === 'single_dropdown') {
      return (column.cell as { value: any }[]).filter(
        (cell: { value: any }) => data.map((element: any) => element[column.field]).indexOf(cell.value) === -1,
      );
    }

    return column.cell as { value: any }[];
  }

  public updateNestedData(nestedData: any, nestedRowIndex: number): void {
    const data = this.dataSubject.value;
    data[nestedRowIndex].fields = nestedData;
    this.dataSubject.next(data);
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/data-sources/custom-data-source.ts